import BaseApi from './BaseApi';

class PaymentApi extends BaseApi {
  protected getSpecificApiPrefix(): string {
    return 'managers/invoices';
  }
}

export default PaymentApi;
